import React, { useState, useEffect } from 'react';
import './SocialProofNotifications.css';

const CUSTOMER_NAMES = ['Owen', 'Sarah', 'Liam', 'Emily', 'Noah', 'Mia', 'Jack', 'Ava', 'Isabella', 'Olivia', 'Emma', 'Ethan', 'Charlotte', 'James', 'Sophia', 'William', 'Amelia', 'Lucas', 'Harper', 'Mason'];

const NOTIFICATION_MESSAGES = [
  { action: 'just booked a repair!', device: 'iPhone 16 Pro Max screen repair' },
  { action: 'just finished a repair!', device: 'Samsung Galaxy battery replacement' },
  { action: 'just booked a repair!', device: 'MacBook Pro charging port fix' },
  { action: 'just completed a repair!', device: 'PS5 controller repair' },
  { action: 'just booked a service!', device: 'Gaming PC RAM upgrade' },
  { action: 'repair completed!', device: 'iPhone 14 battery replacement' },
  { action: 'just booked a repair!', device: 'Samsung S22 Ultra screen repair' },
  { action: 'repair completed!', device: 'Laptop motherboard fix' },
  { action: 'just finished a repair!', device: 'Xbox power supply repair' },
  { action: 'just booked a repair!', device: 'MacBook Air screen replacement' },
  { action: 'repair completed!', device: 'iPhone 13 camera module' },
  { action: 'booking confirmed!', device: 'Samsung Galaxy charging port repair' },
  { action: 'just completed a service!', device: 'Laptop SSD upgrade' },
  { action: 'repair completed!', device: 'Console controller battery replacement' },
  { action: 'repair completed!', device: 'iPhone 12 screen replacement' },
  { action: 'just booked a repair!', device: 'MacBook keyboard replacement' },
  { action: 'repair completed!', device: 'PS4 hard drive swap' },
  { action: 'just booked a repair!', device: 'iPhone 11 back glass replacement' },
  { action: 'repair completed!', device: 'Samsung speaker fix' },
  { action: 'service completed!', device: 'Laptop fan cleaning and optimization' },
  { action: 'repair completed!', device: 'Xbox controller port fix' },
  { action: 'just booked a service!', device: 'Gaming PC graphics card install' },
  { action: 'service completed!', device: 'MacBook battery calibration' },
  { action: 'repair completed!', device: 'Samsung screen replacement' },
  { action: 'just booked a repair!', device: 'iPhone 14 Pro camera repair' },
  { action: 'repair completed!', device: 'Laptop charging port fix' },
  { action: 'just booked a service!', device: 'PS5 system reset' },
  { action: 'repair completed!', device: 'iPhone XR screen replacement' },
  { action: 'repair completed!', device: 'Samsung battery replacement' },
  { action: 'repair completed!', device: 'Laptop keyboard replacement' },
  { action: 'repair completed!', device: 'Xbox controller firmware update' },
  { action: 'just booked a service!', device: 'iPhone 13 screen protector installation' },
  { action: 'service completed!', device: 'Gaming PC BIOS update' },
  { action: 'just booked a repair!', device: 'MacBook Pro battery replacement' },
  { action: 'repair completed!', device: 'Samsung charging port replacement' },
  { action: 'service completed!', device: 'Console fan cleaning' },
  { action: 'repair completed!', device: 'iPhone 12 software fix' },
  { action: 'just booked a repair!', device: 'Laptop motherboard repair' },
  { action: 'repair completed!', device: 'PS4 controller fix' },
  { action: 'repair completed!', device: 'MacBook trackpad replacement' },
  { action: 'service completed!', device: 'Laptop SSD installation' },
  { action: 'repair completed!', device: 'Samsung Galaxy S21 screen replacement' },
  { action: 'just booked a repair!', device: 'iPhone 14 battery swap' },
  { action: 'repair completed!', device: 'Xbox controller battery fix' },
  { action: 'repair completed!', device: 'MacBook Air keyboard replacement' },
  { action: 'repair completed!', device: 'iPhone 13 back glass replacement' },
  { action: 'just booked a repair!', device: 'Samsung S20 camera repair' },
  { action: 'service completed!', device: 'Laptop fan replacement' },
  { action: 'service completed!', device: 'Gaming PC RAM installation' },
  { action: 'just booked a repair!', device: 'iPhone 11 screen replacement' },
  { action: 'just booked a service!', device: 'PS5 controller firmware update' },
  { action: 'repair completed!', device: 'Samsung Galaxy charging port fix' },
  { action: 'repair completed!', device: 'MacBook keyboard replacement' },
  { action: 'repair completed!', device: 'iPhone 14 screen replacement' },
  { action: 'just booked a repair!', device: 'Laptop charging port repair' },
  { action: 'repair completed!', device: 'Xbox power supply replacement' },
  { action: 'repair completed!', device: 'MacBook battery replacement' },
  { action: 'repair completed!', device: 'iPhone 12 camera fix' },
  { action: 'just booked a repair!', device: 'Samsung screen replacement' },
  { action: 'repair completed!', device: 'Laptop motherboard repair' },
  { action: 'service completed!', device: 'Gaming PC SSD installation' },
  { action: 'repair completed!', device: 'iPhone XR battery replacement' },
  { action: 'just booked a repair!', device: 'MacBook Pro charging port fix' },
  { action: 'repair completed!', device: 'Samsung speaker fix' },
  { action: 'service completed!', device: 'Laptop cooling system cleaning' },
  { action: 'just booked a repair!', device: 'Xbox controller battery replacement' },
  { action: 'repair completed!', device: 'iPhone 13 software restore' },
  { action: 'repair completed!', device: 'Laptop keyboard repair' },
  { action: 'repair completed!', device: 'Samsung Galaxy screen replacement' },
  { action: 'just booked a repair!', device: 'PS4 controller repair' },
  { action: 'repair completed!', device: 'MacBook trackpad replacement' },
  { action: 'service completed!', device: 'Gaming PC graphics card installation' },
  { action: 'just booked a repair!', device: 'iPhone 14 back glass replacement' },
  { action: 'repair completed!', device: 'Laptop battery replacement' },
  { action: 'repair completed!', device: 'Samsung Galaxy charging port swap' },
  { action: 'just booked a repair!', device: 'Xbox power supply replacement' },
  { action: 'repair completed!', device: 'MacBook keyboard fix' },
  { action: 'just booked a repair!', device: 'iPhone 12 screen replacement' },
  { action: 'repair completed!', device: 'Laptop motherboard fix' },
  { action: 'service completed!', device: 'Gaming PC RAM upgrade' },
  { action: 'just booked a repair!', device: 'Samsung speaker repair' },
  { action: 'repair completed!', device: 'PS5 controller fix' },
  { action: 'service completed!', device: 'Laptop fan cleaning' },
  { action: 'repair completed!', device: 'iPhone 13 camera replacement' },
  { action: 'just booked a repair!', device: 'MacBook Air battery replacement' },
  { action: 'repair completed!', device: 'Samsung charging port fix' },
  { action: 'repair completed!', device: 'Xbox controller port replacement' },
  { action: 'just booked a service!', device: 'Laptop SSD upgrade' },
  { action: 'repair completed!', device: 'iPhone 14 Pro Max screen replacement' },
  { action: 'repair completed!', device: 'Samsung Galaxy battery replacement' },
  { action: 'just booked a repair!', device: 'MacBook keyboard replacement' },
  { action: 'service completed!', device: 'Gaming PC BIOS update' },
  { action: 'just booked a repair!', device: 'Xbox controller battery replacement' },
  { action: 'repair completed!', device: 'Laptop charger fix' },
  { action: 'repair completed!', device: 'iPhone 11 back glass replacement' },
  { action: 'just booked a repair!', device: 'Samsung Galaxy screen repair' },
  { action: 'repair completed!', device: 'MacBook trackpad fix' },
  { action: 'service completed!', device: 'Laptop cooling system optimization' },
  { action: 'repair completed!', device: 'iPhone 12 software restore' },
  { action: 'just booked a service!', device: 'PS5 system reset' },
  { action: 'repair completed!', device: 'Samsung speaker fix' },
  { action: 'service completed!', device: 'Gaming PC graphics card installation' },
  { action: 'just booked a service!', device: 'Laptop SSD upgrade' },
  { action: 'service completed!', device: 'Gaming PC RAM installation' },
  { action: 'repair completed!', device: 'Xbox controller port fix' },
  { action: 'just booked a repair!', device: 'MacBook Air battery replacement' },
  { action: 'just booked a repair!', device: 'Laptop keyboard replacement' },
  { action: 'repair completed!', device: 'Xbox power supply replacement' },
  { action: 'repair completed!', device: 'iPhone XR screen replacement' },
  { action: 'repair completed!', device: 'Samsung charging port repair' },
  { action: 'service completed!', device: 'MacBook battery calibration' },
  { action: 'just booked a service!', device: 'Gaming PC RAM upgrade' },
  { action: 'repair completed!', device: 'iPhone 13 back glass replacement' },
  { action: 'repair completed!', device: 'Laptop motherboard fix' },
  { action: 'just booked a service!', device: 'Xbox controller firmware update' },
  { action: 'repair completed!', device: 'Samsung screen replacement' },
  { action: 'repair completed!', device: 'MacBook Pro charging port fix' },
  { action: 'service completed!', device: 'Laptop fan replacement' },
  { action: 'repair completed!', device: 'iPhone 14 camera repair' },
  { action: 'just booked a service!', device: 'Gaming PC SSD installation' },
  { action: 'repair completed!', device: 'Samsung Galaxy battery replacement' },
  { action: 'repair completed!', device: 'Xbox controller battery swap' },
  { action: 'just booked a repair!', device: 'Laptop screen replacement' },
  { action: 'repair completed!', device: 'iPhone 11 camera fix' },
  { action: 'just booked a repair!', device: 'MacBook Pro keyboard replacement' },
  { action: 'repair completed!', device: 'Samsung speaker replacement' },
  { action: 'service completed!', device: 'Gaming PC BIOS update' },
  { action: 'just booked a repair!', device: 'PS4 controller repair' },
  { action: 'repair completed!', device: 'iPhone 12 battery replacement' },
  { action: 'service completed!', device: 'Laptop cooling system cleaning' },
  { action: 'just booked a repair!', device: 'Xbox power supply replacement' },
  { action: 'repair completed!', device: 'MacBook keyboard fix' },
  { action: 'repair completed!', device: 'Samsung charging port repair' },
  { action: 'repair completed!', device: 'iPhone 13 screen replacement' },
  { action: 'repair completed!', device: 'iPhone 14 Pro screen replacement' },
  { action: 'just booked a repair!', device: 'Samsung Galaxy battery swap' },
  { action: 'repair completed!', device: 'Laptop keyboard repair' },
  { action: 'service completed!', device: 'Gaming PC graphics card upgrade' },
  { action: 'repair completed!', device: 'PS5 controller repair' },
  { action: 'repair completed!', device: 'MacBook Air screen replacement' },
  { action: 'just booked a repair!', device: 'Xbox controller battery fix' },
  { action: 'repair completed!', device: 'iPhone 13 back glass swap' },
  { action: 'service completed!', device: 'Laptop cooling system cleaning' },
  { action: 'repair completed!', device: 'Samsung screen replacement' },
  { action: 'just booked a service!', device: 'Gaming PC BIOS update' },
  { action: 'repair completed!', device: 'MacBook charging port fix' },
  { action: 'repair completed!', device: 'Xbox controller firmware update' },
  { action: 'just booked a repair!', device: 'Samsung Galaxy screen repair' },
  { action: 'repair completed!', device: 'iPhone 12 camera module replacement' },
  { action: 'just booked a service!', device: 'Laptop SSD installation' },
  { action: 'service completed!', device: 'Gaming PC RAM upgrade' },
  { action: 'repair completed!', device: 'MacBook battery replacement' },
  { action: 'just booked a service!', device: 'PS5 system reset and repair' },
  { action: 'repair completed!', device: 'iPhone XR screen replacement' },
  { action: 'service completed!', device: 'Laptop fan replacement' },
  { action: 'repair completed!', device: 'Samsung Galaxy charging port fix' },
  { action: 'just booked a repair!', device: 'Xbox power supply repair' },
  { action: 'repair completed!', device: 'MacBook trackpad replacement' },
  { action: 'repair completed!', device: 'iPhone 14 software fix' },
  { action: 'service completed!', device: 'Gaming PC graphics card installation' },
  { action: 'just booked a repair!', device: 'Samsung Galaxy battery replacement' },
  { action: 'repair completed!', device: 'Laptop keyboard replacement' },
  { action: 'repair completed!', device: 'Xbox controller port repair' },
  { action: 'just booked a repair!', device: 'iPhone 11 screen replacement' },
  { action: 'service completed!', device: 'MacBook Air battery calibration' },
  { action: 'repair completed!', device: 'Samsung speaker module fix' },
  { action: 'just booked a service!', device: 'Gaming PC RAM upgrade' },
  { action: 'repair completed!', device: 'iPhone 13 camera replacement' },
  { action: 'service completed!', device: 'Laptop cooling system optimization' },
  { action: 'just booked a repair!', device: 'Xbox controller battery swap' },
  { action: 'repair completed!', device: 'MacBook charging port repair' },
  { action: 'repair completed!', device: 'Samsung Galaxy screen replacement' },
  { action: 'just booked a repair!', device: 'PS4 controller repair' },
  { action: 'repair completed!', device: 'iPhone 14 Pro Max back glass replacement' },
  { action: 'repair completed!', device: 'Laptop keyboard fix' },
  { action: 'service completed!', device: 'Gaming PC SSD installation' },
  { action: 'repair completed!', device: 'Samsung Galaxy software repair' },
  { action: 'repair completed!', device: 'MacBook Pro battery replacement' },
  { action: 'just booked a service!', device: 'Xbox controller firmware update' },
  { action: 'repair completed!', device: 'iPhone XR battery replacement' },
  { action: 'repair completed!', device: 'Laptop motherboard fix' },
  { action: 'just booked a repair!', device: 'Samsung Galaxy charging port replacement' },
  { action: 'repair completed!', device: 'PS5 controller battery swap' },
  { action: 'just booked a repair!', device: 'Xbox controller battery replacement' },
  { action: 'service completed!', device: 'Gaming PC graphics card upgrade' },
  { action: 'repair completed!', device: 'iPhone 14 camera module replacement' },
  { action: 'service completed!', device: 'Laptop cooling system cleaning' },
  { action: 'just booked a repair!', device: 'MacBook Pro trackpad replacement' },
  { action: 'repair completed!', device: 'Samsung Galaxy battery replacement' },
  { action: 'just booked a repair!', device: 'PS4 controller repair' },
  { action: 'repair completed!', device: 'iPhone 13 screen replacement' },
  { action: 'service completed!', device: 'Laptop SSD installation' },
  { action: 'just booked a repair!', device: 'Xbox power supply fix' },
  { action: 'repair completed!', device: 'MacBook keyboard replacement' },
  { action: 'service completed!', device: 'Gaming PC RAM upgrade' },
  { action: 'repair completed!', device: 'iPhone 12 battery replacement' }
];

const SocialProofNotifications = () => {
  const [currentNotification, setCurrentNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const showNotification = () => {
      // Select random customer name
      const randomName = CUSTOMER_NAMES[Math.floor(Math.random() * CUSTOMER_NAMES.length)];

      // Select random message
      const randomMessage = NOTIFICATION_MESSAGES[Math.floor(Math.random() * NOTIFICATION_MESSAGES.length)];

      setCurrentNotification({
        name: randomName,
        action: randomMessage.action,
        device: randomMessage.device
      });
      setIsVisible(true);

      // Hide after 10 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 10000);

      // Show next notification after random delay (2-10 seconds after current one ends)
      setTimeout(() => {
        showNotification();
      }, 10000 + (Math.random() * 8000 + 2000)); // 10s display + 2-10s delay
    };

    // Initial delay before first notification (2-10 seconds)
    const initialDelay = Math.random() * 8000 + 2000;
    const timeoutId = setTimeout(() => {
      showNotification();
    }, initialDelay);

    return () => clearTimeout(timeoutId);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!currentNotification) return null;

  return (
    <div className={`social-proof-notification ${isVisible ? 'visible' : ''}`}>
      <div className="notification-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="#10B981"/>
          <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="notification-content">
        <p className="notification-title">{currentNotification.name} {currentNotification.action}</p>
        <p className="notification-device">{currentNotification.device}</p>
        <p className="notification-time">just now</p>
      </div>
      <button className="notification-close" onClick={handleClose} aria-label="Close notification">
        ×
      </button>
    </div>
  );
};

export default SocialProofNotifications;
